/* eslint func-names:0, object-shorthand:0, quote-props:0, max-len: 0 */
export const routeBuilders = {
  rootRoute: () => routeBuilders.inboxRoute(),
  conversationListRoute: (filter, doctorId, pageNumber = 1) =>
    `/conversations/${filter}/${doctorId}/${pageNumber}`,
  listRoute: (listId, pageNumber = 1) => `/lists/${listId}/${pageNumber}`,
  unassignedConversationListRoute: (pageNumber = 1, status = 'open') =>
    `/conversations/unassigned/${status}/${pageNumber}`,
  searchRoute: (query) => `/search${query ? `/${query}` : ''}`,
  conversationRoute: (conversationId, messageId = '') =>
    messageId
      ? `/conversations/${conversationId}/messages/${messageId}`
      : `/conversations/${conversationId}`,
  videoVisitEndedRoute: (conversationId) => `/video-visit-ended/${conversationId}`,
  videoVisitCompletedRoute: (conversationId) => `/video-visit-completed/${conversationId}`,
  conversationExportRoute: (conversationId) => `/conversations/${conversationId}/export`,
  conversationExportEhrRoute: (conversationId, messageId) =>
    messageId
      ? `/conversations/${conversationId}/ehr/export/messages/${messageId}`
      : `/conversations/${conversationId}/ehr/export/`,
  conversationSelectMessagesForTaskRoute: (conversationId, messageId) =>
    messageId
      ? `/conversations/${conversationId}/tasks/select-messages/${messageId}`
      : `/conversations/${conversationId}/tasks/select-messages`,
  conversationCreateTaskRoute: (conversationId, messageIds) => {
    const base = routeBuilders.newTaskRoute(conversationId);
    if (!messageIds?.length) return base;

    const params = new URLSearchParams({ messageIds: messageIds.join(',') });

    return `${base}?${params.toString()}`;
  },
  newPatientsRoute: () => '/patients/new',
  forgotPasswordRoute: () => '/reset-password',
  forgotPasswordSuccessRoute: () => '/reset-password/success',
  loginRoute: () => '/login',
  logoutRoute: () => '/logout',

  notificationSettingsRoute: () => '/notification-settings',
  officeHoursSettingsRoute: () => '/team-settings/office-hours',
  newReportsRoute: (pageNumber = 1) => `/reporting/${pageNumber}`,
  paymentsRoute: () => '/team-settings/payments',
  configureSchedulingRoute: () => '/team-settings/configure-scheduling',
  configureSchedulingLinkRoute: () => '/team-settings/configure-scheduling/link',
  configureAppointmentAvailabilitiesRoute: () =>
    '/team-settings/configure-scheduling/appointment-availabilities',
  configureInsuranceInfoRoute: () => '/team-settings/configure-scheduling/insurance-info',
  configureQuestionnaireRoute: () => '/team-settings/configure-scheduling/questionnaire',
  createQuestionRoute: () => '/team-settings/configure-scheduling/questionnaire/new',
  editQuestionRoute: (questionId) =>
    `/team-settings/configure-scheduling/questionnaire/${questionId}/edit`,
  previewQuestionnaireRoute: () => `/team-settings/configure-scheduling/questionnaire/preview`,
  inboundReferralsRoute: () => '/team-settings/inbound-referrals',
  sharedPatientsRoute: () => '/team-settings/shared-patients',
  listMessageAutomations: () => '/team-settings/message-automations',
  createMessageAutomation: () => '/team-settings/message-automations/create',
  editMessageAutomation: (messageAutomationId) =>
    `/team-settings/message-automations/${messageAutomationId}`,
  inboundReferralRequestRoute: (conversationId, requestId) =>
    `/conversations/${conversationId}/referral-requests/${requestId}`,
  mergePatientsRoute: (piToMerge, piToKeep, conversationId) => {
    const base = piToKeep
      ? `/patients/merge/${piToMerge}/${piToKeep}`
      : `/patients/merge/${piToMerge}`;
    return conversationId ? `${base}?conversationId=${conversationId}` : base;
  },
  patientRoute: (patientId) => `/patients/${patientId}`,
  patientIdentityRoute: (patientIdentityId) => `/patients/${patientIdentityId}/view`,
  editPatientIdentityRoute: (patientIdentityId) => `/patients/${patientIdentityId}/edit`,
  editPatientIdentityContactsRoute: (patientIdentityId) =>
    `/patients/${patientIdentityId}/contacts`,
  newConversationRoute: (patientIdentityId) => `/patients/${patientIdentityId}/conversations/new`,
  chargePatientRoute: (patientIdentityId) => `/patients/${patientIdentityId}/payment/charge`,
  connectModMedRoute: () => '/team-settings/payments/modmed/connect',
  messageTemplatesRoute: (messageTemplateId) =>
    `/team-settings/message-templates/${messageTemplateId}`,
  manageListsRoute: () => '/team-settings/manage-lists',
  customListsRoute: () => '/team-settings/manage-lists/custom',
  unassignedListsRoute: () => '/team-settings/manage-lists/unassigned',
  configureRoutingRoute: () => '/team-settings/manage-lists/unassigned/configure-routing',
  configureRoutingFallbackRoute: () => '/team-settings/manage-lists/unassigned/configure-fallback',
  messageRoutingRoute: () => '/team-settings/manage-lists/unassigned/message-routing',
  subscribeStaffToRoutingRoute: () => '/team-settings/manage-lists/unassigned/subscribe',
  autoCloseRoute: () => '/team-settings/manage-lists/auto-close',
  autoReplyRoute: () => '/team-settings/manage-lists/auto-reply',
  aiPrioritizationRoute: () => '/team-settings/manage-lists/ai-prioritization',
  aiSummaryRoute: () => '/team-settings/manage-lists/ai-summary',
  filterVisibilityRoute: () => '/team-settings/manage-lists/filter-visibility',
  autoReplyReasonsRoute: (id, slug) => `/team-settings/manage-lists/auto-reply/${id}/${slug}`,
  manageTemplatesRoute: () => '/team-settings/message-templates',
  teamMembersRoute: () => '/team-settings/team-members',
  editMemberRoute: (id) => `/team-settings/edit-member/${id}`,
  journeyStepRoute: (id) => `/team-settings/automated-communications/journey-step/${id}`,
  workflowsRoute: () => '/team-settings/workflows',
  automatedCommunicationsRoute: () => '/team-settings/automated-communications',
  patientIntakeRoute: (page = 1) => `/team-settings/patient-intake/${page}`,
  patientIntakeSettingsRoute: () => '/team-settings/patient-intake/settings',
  newPatientIntakeRoute: () => `/team-settings/patient-intake/new`,
  editPatientIntakeRoute: (intakeId) => `/team-settings/patient-intake/${intakeId}/edit`,
  manageEFormsRoute: () => '/team-settings/manage-eforms',
  editReasonRoute: (reasonId) => `/team-settings/reasons/${reasonId}`,
  reasonsRoute: () => '/team-settings/reasons',
  locationsRoute: () => '/team-settings/locations',
  editLocationRoute: (locationId) => `/team-settings/locations/${locationId}`,
  locationRoutingRoute: () => '/team-settings/location-routing',
  providersRoute: () => '/team-settings/providers',
  editProviderRoute: (providerId) => `/team-settings/providers/${providerId}`,
  inboxRoute: (pageNumber = 1) => `/inbox/${pageNumber}`,
  closingAgentRoute: () => '/ai-assistant/closing-agent',
  combinedInboxRoute: (pageNumber = 1) => `/inbox/combined/${pageNumber}`,
  videoVisitsRoute: (pageNumber = 1) => `/video-visits/${pageNumber}`,
  editListRoute: (listId) => `/team-settings/manage-lists/${listId}`,
  newListRoute: () => '/team-settings/manage-lists/new',
  mentionsRoute: (pageNumber = 1) => `/mentions/${pageNumber}`,
  editProfileRoute: () => '/me/profile',
  editPasswordRoute: () => '/me/password',
  settingsRoute: () => '/me/settings',
  editPhoneRoute: () => '/me/2fa',
  ehrImportRoute: (query) => `/ehr-import${query ? `/${encodeURIComponent(query)}` : ''}`,
  ehrLinkPatientRoute: (patientIdentityId, query, conversationId) => {
    const base = `/patients/${patientIdentityId}/link${query ? `/${encodeURIComponent(query)}` : ''}`;
    return conversationId ? `${base}?conversationId=${conversationId}` : base;
  },
  newVideoCallRoute: (conversationId) => `/conversations/${conversationId}/video-calls/new`,
  videoVisitRoute: (conversationId) => `/conversations/${conversationId}/video-visit`,
  setup2FARoute: () => '/2fa/add',
  verifyPhoneRoute: () => '/2fa/verify',
  broadcastRoute: () => '/broadcast',
  broadcastViewPatientsRoute: (broadcastId) => `/broadcast/${broadcastId}`,
  broadcastComposeMessageRoute: (broadcastId) => `/broadcast/${broadcastId}/send`,
  broadcastSearchRoute: () => '/broadcast/search',
  broadcastScheduleRoute: () => '/broadcast/schedule/search',
  switchTeamRoute: (teamId) => `/me/switch/${teamId}`,
  teamSwitchRoute: (token) => `${routeBuilders.rootRoute()}?authToken=${token}`,
  pendingAppointmentsRoute: (pageNumber = 1) => `/pending-appointments/${pageNumber}`,
  ehrTroubleshootingRoute: (pageNumber = 1) => `/ehr-troubleshooting/${pageNumber}`,
  riskyPatientSyncsRoute: () => `/risky-patients`,
  assistantRoute: () => '/assistant',
  resolveRiskyPatientSyncRoute: (conversationId) => `/risky-patients/${conversationId}/resolve`,
  newTaskRoute: (conversationId) => `/conversations/${conversationId}/tasks/createnewtask`,
};
